module.exports = __webpack_public_path__ + "static/media/main-bg.0aa19d3c.jpg";